import { Platform } from '@/features/pages';
import { Departments } from '@/types';

export namespace contentTypes {
  export type ContentType = 'text' | 'photo' | 'video' | 'audio' | 'document';

  export type Status = 'active' | 'inactive' | 'archived';

  export type Item = {
    _id: string;
    type: ContentType;
    name: string;
    category: string;
    status: Status;
    filename?: string;
    size: number;
    textContent?: string;
    url?: string;
    department: Departments;
    pageId: string;
    platform: Platform;
    createdAt: number;
  };

  export type ItemFields = Pick<
    Item,
    'type' | 'name' | 'category' | 'status' | 'filename' | 'size' | 'textContent' | 'url'
  >;
}
